import React, { useState } from 'react';
import { Container, Card, Form, Button, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { getApiUrl } from '../../config/api';

const AdminLogin = ({ onLogin }) => {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const API_URL = getApiUrl('AUTH');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password })
      });

      const data = await response.json();

      if (data.success) {
        localStorage.setItem('adminToken', data.token);
        onLogin();
        navigate('/admin/dashboard');
      } else {
        setError(data.message);
      }
    } catch (err) {
      setError('Connection error. Make sure the server is running.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      background: 'linear-gradient(135deg, #008080 0%, #0A7A6F 100%)', 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center' 
    }}>
      <Container>
        <Card style={{ 
          maxWidth: '450px', 
          margin: '0 auto', 
          borderRadius: '15px', 
          boxShadow: '0 10px 40px rgba(0,0,0,0.2)' 
        }}>
          <Card.Body className="p-5">
            <div className="text-center mb-4">
              <h2 style={{ color: 'var(--teal-primary)', fontWeight: '700' }}>
                🔒 Admin Access
              </h2>
              <p className="text-muted">Enter password to continue</p>
            </div>
            
            {error && <Alert variant="danger">{error}</Alert>}
            
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-4">
                <Form.Label className="fw-semibold">Password</Form.Label>
                <Form.Control
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter admin password"
                  required
                  style={{ padding: '0.75rem', fontSize: '1rem' }}
                  autoFocus
                />
              </Form.Group>

              <Button 
                type="submit" 
                className="w-100 btn-teal"
                disabled={loading}
                style={{ padding: '0.75rem', fontSize: '1rem' }}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Verifying...
                  </>
                ) : (
                  <>
                    🚀 Login
                  </>
                )}
              </Button>
            </Form>

            <div className="text-center mt-4">
              <a href="/" className="text-decoration-none" style={{ color: 'var(--teal-primary)' }}>
                ← Back to Home
              </a>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default AdminLogin;